module.exports = __webpack_public_path__ + "img/上海学校bg.1f4dad75.png";